import {Alert, Anchor, Box, Button, Stack, Text, Title} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ProfileMfaSectionProps {
  mfaEnabled: boolean;
}

export default function ProfileMfaSection(props: ProfileMfaSectionProps): JSX.Element {
  return (
    <Box>
      <Stack spacing="sm">
        <Title order={2}>Multi-factor authentication (MFA)</Title>
        {props.mfaEnabled ? (
          <Alert
            variant="success"
            icon={<BenchlingIcon icon="check-circle" />}
            title="Your account is secured with MFA"
          >
            Use the app on your mobile device to sign in
          </Alert>
        ) : (
          <>
            <Text size="sm">
              Multi-factor authentication secures your account with a OTP (One Time Password) application.{' '}
              <Anchor href="" target="_blank" rel="noopener noreferrer">
                Learn more
              </Anchor>
            </Text>
            <Button component="a" href="/settings/mfa" variant="secondary" size="xs" w="fit-content">
              Enable Multi-factor authentication
            </Button>
          </>
        )}
      </Stack>
    </Box>
  );
}
